<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.documents.tagName`),
      tagLink: `${searchResult.link}/documents`,
    }"
    class="document-card result-card"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:file-text"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="`${searchResult.url}`"
        class="title"
      >
        {{ searchResult.name }}
      </a>
      <div class="bottom-bar">
        <button
          v-if="!isMobileView"
          class="download-button"
          :aria-label="$t('search.download', { docName: searchResult.name, fileType: searchResult.file_extension })"
          @click.stop="downloadFile"
        >
          <Icon
            name="lucide:download"
            size="14"
          />
          {{ $t('search.documents.downloadTag') }}
        </button>
        <span class="size">{{ $t('search.documents.fileSize') }}: {{ searchResult.file_size }}</span>
        <span class="date">{{ $t('search.forms.published') }}: {{ monthDayYear(searchResult.created_at) }}</span>
        <!-- <span class="updated-date">Updated: 2023-10-15</span> -->
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { monthDayYear } from '../../../helpers/date-utils';
import { useScreenBreakpoints } from '@/composables/useBreakpoints';
const { isMobileView } = useScreenBreakpoints();

const props = defineProps({
  searchResult: {
    type: Object,
    required: true,
  },
});

function downloadFile() {
  if (!props.searchResult || !props.searchResult.url) {
    console.error('Document URL not available');
    return;
  }

  const link = document.createElement('a');
  link.href = props.searchResult.url;
  link.target = '_blank';
  link.download = props.searchResult.name || 'document';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<style lang="scss" scoped>
@use '../../global/scss/mixins/_breakpoints.scss' as bp;

.document-card {
  --background-color: var(--color-orange-50);
  --text-color: var(--color-orange-500);

  --color-orange-50: #fffaf4;
  --color-orange-500: #f39529;
  --color-purple-300: #d6c2e0;
  --color-purple-700: #4b1f6d;
  --color-text-tertiary: #949494;

  .bottom-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;

    .date,
    .size {
      font-size: 12px;
      color: var(--color-text-tertiary);
    }

    .download-button {
      display: inline-flex;
      padding: 4px 8px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 100px;
      background: var(--secondary-button-background);
      border: var(--secondary-button-border);
      cursor: pointer;
      color: var(--secondary-button-text);
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 16px;
      letter-spacing: 0.5px;
      &:hover {
        background-color: var(--secondary-button-hover);
      }
      &:focus-visible {
        outline: var(--secondary-button-focus-outline);
        outline-offset: 1px;
        border: var(--secondary-button-hover-border);
      }
    }
  }
}
@include bp.screen('<=sm') {
  .document-card {
    .bottom-bar {
      align-items: flex-start;
      flex-direction: column-reverse;
    }
  }
}
</style>
